const mapObjectProperties = (obj, mapper) => (
  Object.entries(obj).reduce((mappedObject, [key, value]) => {
    mappedObject[key] = mapper(key, value);
    return mappedObject;
  }, {})
);

export default mapObjectProperties;
